import { Box } from "@material-ui/core"
import { ReactNode } from "react"

export function ChartColumn({ children }: { children: ReactNode }) {
  return (
    <Box display="flex" flexDirection="column" width="100%">
      {children}
    </Box>
  )
}
